<template>
    <div>
        <div class="p-fluid">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label for="status">Status</label>
                    <Dropdown v-model="filters.status" :options="dataDropdownStatus" optionLabel="name" optionValue="code" placeholder="Select a Status" :showClear="true"/>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>Outlet Type</label>
                    <Dropdown id="otype_id" dataKey="otype_id" v-model="filters.otype_name" :loading="loadingDropdownOutletType"
                        :options="dataDropdownOutletType"
                        optionLabel="otype_name" optionValue="otype_name" placeholder="Select Outlet Type"
                        :filter="true" :showClear="true" @filter="searchDropdownOutletType($event, 'filter')" />
                </div>
            </div>
        </div>
        <Button :loading="loading" label="Filter" icon="pi pi-search" class="p-button-warning mr-2 my-1" @click="getDataTable" />
    </div>
</template>

<script>

import moment from 'moment';

export default {
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownTerritory: false,
            loadingDropdownOutletType: false,

            // dataDropdown
            dataDropdownTerritory: null,
            dataDropdownOutletType: null,
            dataDropdownStatus: [
                {name: 'ACTIVE', code: 'y'},
                {name: 'NON ACTIVE', code: 'n'},
            ],

            // filter
            filters: {
                territory_id: null,
                otype_name: null,
                status: null,
            },
            period: [new Date(), new Date()],
            maxDate: null,
        }
    },
    mounted() {
        // this.searchDropdownTerritory('');
        this.searchDropdownOutletType('');
    },
    created(){
    },
    watch: {
        period(){
            //max range 30 days
            this.maxDate =  new Date(this.period[0].getFullYear(), this.period[0].getMonth(), this.period[0].getDate() + 30);
        }
    },
    computed:{
        period_start_label(){ 
            return moment(this.period[0], 'YYYY-MM-DD').format('YYYY-MM-DD'); 
        },
        period_end_label(){ 
            return moment(this.period[1], 'YYYY-MM-DD').format('YYYY-MM-DD'); 
        },
    },
    methods: {
        // DROPDOWN
        searchDropdownTerritory(event, purpose, valueEdit) {
            setTimeout(() => {

                if (valueEdit) {
                    this.$refs.dterritory.filterValue = valueEdit;
                }

                if (purpose == "filter") {
                    this.loadingDropdownTerritory = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-territory',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                    }
                })
                    .then(res => {

                        if (purpose == "filter") {
                            this.dataDropdownTerritory = res.data.data;
                            this.loadingDropdownTerritory = false;
                        } else if (purpose == null) {
                            this.dataDropdownTerritory = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
        searchDropdownOutletType(event, purpose, valueEdit){
            setTimeout(() => {
                if(valueEdit){
                    this.$refs.dotype.filterValue = valueEdit;
                }

                if(purpose == "filter"){
                    this.loadingDropdownOutletType = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/outlet-type',
                    params: {
                        "search" : valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if(purpose == "filter"){
                        this.dataDropdownOutletType = res.data.data;
                        this.loadingDropdownOutletType = false;
                    }else if(purpose == null){
                        this.dataDropdownOutletType = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        getDataTable(){
            if(
              this.period_start_label !== null && 
              this.period_end_label !== null && 
              this.period_start_label !== 'Invalid date' && 
              this.period_end_label !== 'Invalid date'
            ){  
                this.$emit('submit');
            }else{
                 alert('Make sure the time range is correct or not empty');
            }
        }
    }
}
</script>

